import { MessagePosition } from '@/shared/types/message';

export const useMessageStyles = () => {
  const getPositionClasses = (position: MessagePosition) => {
    const positionClasses: Record<MessagePosition, string> = {
      'top-left': 'ui-fixed ui-top-5 ui-left-5',
      'top-center': 'ui-fixed ui-top-5 ui-left-1/2 ui--translate-x-1/2',
      'top-right': 'ui-fixed ui-top-5 ui-right-5',
      'center-left': 'ui-fixed ui-top-1/2 ui-left-5 ui--translate-y-1/2',
      center: 'ui-fixed ui-top-1/2 ui-left-1/2 ui--translate-x-1/2 ui--translate-y-1/2',
      'center-right': 'ui-fixed ui-top-1/2 ui-right-5 ui--translate-y-1/2',
      'bottom-left': 'ui-fixed ui-bottom-5 ui-left-5',
      'bottom-center': 'ui-fixed ui-bottom-5 ui-left-1/2 ui--translate-x-1/2',
      'bottom-right': 'ui-fixed ui-bottom-5 ui-right-5',
    };

    const classes = positionClasses[position];

    if (process.env.NODE_ENV !== 'production' && !classes) {
      // eslint-disable-next-line no-console
      console.warn(
        `[useMessageStyles] Invalid position "${position}". Using "top-right" as fallback.`,
      );
      return positionClasses['top-right'];
    }

    return classes || positionClasses['top-right'];
  };

  return {
    getPositionClasses,
  };
};
